// Removed Wifi import as it's no longer needed for the logo
// import { Wifi } from 'lucide-react'
import { AnimatedSection } from "./AnimatedSection"
import { Fragment } from "react"
import { VizagLogo } from "./VizagLogo"

export function Footer({ currentEdition }) {
  const Wrapper = currentEdition === "vizag-2026" ? Fragment : AnimatedSection
  return (
    <Wrapper>
      <footer className="bg-green-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              {currentEdition === "vizag-2026" ? <VizagLogo className="w-32 shadow-lg sm:w-36" /> : <img src={currentEdition === "chennai" ? "/images/CTS_chennai_logo.png" : "/images/cts_logo.png"} alt="CTS Logo" className="h-10 w-auto" />}
            </div>
            <p className="text-green-200 mb-6">Candela Technology Summit - Advancing Wireless Innovation</p>
            <p className="text-green-300 text-sm">© 2026 CTS Event</p>
          </div>
        </div>
      </footer>
    </Wrapper>
  )
}
